<template>
    <div class="AddSupplierManager">
        <div class="head">
            <el-breadcrumb style="margin: auto auto auto 20px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'supplierManager' }">供应商管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px"
                     size="small" style="width: 55%; margin-left: 15%">
                <el-form-item label="供应商公司名称" prop="name">
                    <el-input v-model="ruleForm.name"/>
                </el-form-item>
                <el-form-item label="供应商类型" prop="type">
                    <el-input v-model="ruleForm.type"/>
                </el-form-item>
                <el-form-item label="公司地址" prop="address">
                    <el-input v-model="ruleForm.address"/>
                </el-form-item>
                <el-form-item label="联系人" prop="contact">
                    <el-input v-model="ruleForm.contact"/>
                </el-form-item>
                <el-form-item label="联系电话" prop="contactTel">
                    <el-input v-model="ruleForm.contactTel" type="number"/>
                </el-form-item>
                <el-form-item label="供应商风险评级" prop="riskLevel">
                    <el-input v-model="ruleForm.riskLevel"/>
                </el-form-item>
                <el-form-item label="供应商类别" prop="classify">
                    <el-input v-model="ruleForm.classify"/>
                </el-form-item>
                <el-form-item label="邮政编码" prop="postcode">
                    <el-input v-model="ruleForm.postcode" type="number"/>
                </el-form-item>
                <el-form-item label="经营范围" prop="businessScope">
                    <el-input v-model="ruleForm.businessScope"/>
                </el-form-item>
                <el-form-item label="公司描述" prop="intro">
                    <el-input v-model="ruleForm.intro" type="textarea" :rows="3"/>
                </el-form-item>
                <el-form-item label="考核日期" prop="assessTime">
                    <el-date-picker
                            v-model="ruleForm.assessTime"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="总分" prop="score">
                    <el-input v-model="ruleForm.score" type="number"/>
                </el-form-item>
                <el-form-item label="考核结果" prop="result">
                    <el-input v-model="ruleForm.result"/>
                </el-form-item>
                <el-form-item label="证书名称" prop="cerName">
                    <el-input v-model="ruleForm.cerName"/>
                </el-form-item>
                <el-form-item label="证书编号" prop="cerNum">
                    <el-input v-model="ruleForm.cerNum"/>
                </el-form-item>
                <el-form-item label="是否有有效期" prop="indate">
                    <el-radio-group v-model="ruleForm.indate" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" label-width="0" style="margin-bottom: 10px">
                    <el-col :span="12">
                        <el-form-item label="取证日期" prop="licenceIssued">
                            <el-date-picker
                                    v-model="ruleForm.licenceIssued"
                                    type="date"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="到期日期" prop="expiringDate">
                            <el-date-picker
                                    v-model="ruleForm.expiringDate"
                                    type="date"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-form-item>
                <el-form-item label="考核标题" prop="assessTitle">
                    <el-input v-model="ruleForm.assessTitle" type="textarea"/>
                </el-form-item>
                <el-form-item label="考核部门" prop="assessDep">
                    <el-input v-model="ruleForm.assessDep"/>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {supplierManagerAdd, supplierManagerEdit} from '@/api/processManager'

    export default {
        name: 'AddSupplierManager',
        data() {
            return {
                ruleForm: {},
                rules: {
                    name: [{required: true, message: '请输入供应商公司名称'}],
                    type: [{required: true, message: '请输入供应商类型'}],
                    address: [{required: true, message: '请输入公司地址'}],
                    contact: [{required: true, message: '请输入联系人'}],
                    contactTel: [{required: true, message: '请输入联系电话'}],
                    riskLevel: [{required: true, message: '请输入供应商风险评级'}],
                    classify: [{required: true, message: '请输入供应商类别'}],
                    postcode: [{required: true, message: '请输入邮政编码'}],
                    businessScope: [{required: true, message: '请输入经营范围'}],
                    intro: [{required: true, message: '请输入公司描述'}],
                    assessTime: [{required: true, message: '请选择考核日期'}],
                    score: [{required: true, message: '请输入总分'}],
                    result: [{required: true, message: '请输入考核结果'}],
                    cerName: [{required: true, message: '请输入证书名称'}],
                    cerNum: [{required: true, message: '请输入证书编号'}],
                    indate: [{required: true, message: '请选择是否有有效期'}],
                    licenceIssued: [{required: true, message: '请选择取证日期'}],
                    expiringDate: [{required: true, message: '请选择到期日期'}],
                    assessTitle: [{required: true, message: '请输入考核标题'}],
                    assessDep: [{required: true, message: '请输入考核部门'}],
                }
            }
        },
        created() {
            if (this.$route.params.key) {
                this.ruleForm = this.$route.params.key
            }
        },
        methods: {
            // 保存
            submit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        // 编辑
                        if (this.$route.params.key) {
                            supplierManagerEdit({...this.ruleForm}).then(res => {
                                this.$message.success('编辑成功')
                                this.$router.push('supplierManager')
                            })
                        }
                        // 新增
                        else {
                            supplierManagerAdd({...this.ruleForm}).then(res => {
                                this.$message.success('新增成功')
                                this.$router.push('supplierManager')
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>
    .AddSupplierManager /deep/ .el-form-item {
        margin-bottom: 25px
    }
</style>
